import React from 'react';
import './LoadingSpinner.scss';

const LoadingSpinner: React.FC = () => {
  return <div className='spinner'></div>;
};

export default LoadingSpinner;
